import { render } from "./tabellaPrenotazioni.vue?vue&type=template&id=22edaf2a&ts=true"
import script from "./tabellaPrenotazioni.vue?vue&type=script&lang=ts"
export * from "./tabellaPrenotazioni.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__